module.exports = __webpack_public_path__ + "static/media/florentino.eb421f80.jpg";